<template>
  <div >
    <div class="theader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>短信监控</el-breadcrumb-item>
        <el-breadcrumb-item>短信统计</el-breadcrumb-item>

      </el-breadcrumb>
      <div class="depArea" v-if="user.username == 'admin'">
        <el-form inline>
          <el-form-item label="选择部门" >
            <el-select v-model="depId" size="small" @change="changeDepId">
              <el-option v-for="item in deptData" :label="item.departmentName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>


    <el-row :gutter="50">
      <el-col :span="6">
        <div class="yetx txItem">
          <p class="title">余额提醒</p>
          <div class='txLable'>{{yetx}}</div>
        </div>
        <div class="bgtx txItem">
          <p class="title">变更提醒</p>
          <div class='txLable'>{{bgtx}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="cztx txItem">
          <p class="title">充值提醒</p>
          <div class='txLable'>{{cztx}}</div>
        </div>
        <div class="khtx txItem">
          <p class="title">开户提醒</p>
          <div class='txLable'>{{khtx}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="qftx txItem">
          <p class="title">欠费提醒</p>
          <div class='txLable'>{{qftx}}</div>
        </div>
        <div class="qt txItem">
          <p class="title">其他</p>
          <div class='txLable'>{{qd}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="htzs">
          <p class="title">合同总数</p>
          <div class='txLable' style="padding-top: 30px;">{{htzs}}</div>
          <p class="yfs"><span style="font-size: 18px;">已发送：</span>{{yfs}}</p>
        </div>
      </el-col>

    </el-row>

    <el-row :gutter="50">
      <el-col :span="12">
        <div class="">
          <div class="sheader" style="display: flex;">
            <div style="margin-right: 10px;"><i   class="el-icon-s-promotion icon"></i>每日发送</div>
            <div>
              <el-date-picker
                @change="getFenLei"
                size="mini"
                v-model="date"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择月">
              </el-date-picker>
            </div>
          </div>
          <div class="paybox">
            <div class="cavasbox" ref="fengLei"></div>
          </div>
        </div>

      </el-col>
      <el-col :span="12">
        <div class="">
          <div class="sheader"><i class="el-icon-pie-chart icon"></i>短信类型统计</div>
          <div class="paybox" style="padding-top: 20px;">
            <!-- <p style="text-align: center;color: ddd; font-size: 14px;" v-if="noData">暂无数据</p> -->
            <div class="cavasbox" ref="payEchart"></div>
          </div>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Chart from 'echarts'
  import 'echarts/theme/macarons.js'
  import {departmentList} from '../../api/userMG'
  import { timestampToTime } from '../../utils/util'
  import {
    findDayMsgDetailByDepId,
    msgContractTotal,
    findMsgDetailGroupTotal
  } from '../../api/summaryMG.js'
  export default {
    data() {
      return {
        depId: '',
        depId1: "",
        qftx: "--",
        yetx: "--",
        cztx: "--",
        khtx: "--",
        bgtx: "--",
        qd: "--",
        htzs: '--',
        yfs: "--",
        deptData:[],
        user:{},
        date:""
      }
    },
    created() {


       this.getdept()



    },
    mounted() {
      this.date = timestampToTime(new Date()).substring(0,7)
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

      if(this.user.username != 'admin'){
        this.depId = this.user.departmentId
      }else{
        this.depId = 6
      }
      this.getFenLei()
      this.getPieData()
      this.getTongJi()
    },
    methods: {

      changeDepId(){
        
        this.qftx =  "--"
        this.yetx =  "--"
        this.cztx =  "--"
        this.khtx =  "--"
        this.bgtx =  "--"
        this.qd =  "--"
        this.htzs =  '--'
        this.yfs =  "--"

        this.getTongJi()
        this.getdept()
        this.getFenLei()
        this.getPieData()
      },

      //获取所有的部门信息
      getdept(){
      	departmentList().then(res => {
      		if(res.status == 1){
      			this.deptData = res.data
      		}else{
      			this.$message.error(res.msg)
      		}
      	})
      	.catch(err => {
      	  this.loading = false
      	  this.$message.error('获取部门信息失败，请稍后再试！')
      	})
      },
      getFenLei() {
        let param = {
          depId: this.depId,
          date: this.date
        }
        findDayMsgDetailByDepId(param).then(res => {
          if (res.status == 1) {
            let option = {
              tooltip: {
                trigger: 'axis'
              },
              calculable: true,
              xAxis: [{
                type: 'category',
                data: res.data.dayList
              }],
              yAxis: [{
                  type: 'value',
                  axisLabel: {
                    formatter: '{value}',
                    textStyle: {
                      color: '#2ec7c9'
                    }
                  }
                }
              ],
              series: [
                {
                  name: '数量',
                  type: 'line',
                  data: res.data.totals
                }
              ]
            }
            this.chart = Chart.init(this.$refs.fengLei, 'macarons')
            this.chart.setOption(option)
          }
        })
      },
      getTongJi() {
        // 1.欠费提醒
        // 2.余额提醒
        // 3.充值提醒
        // 4.开户提醒
        // 5.变更提醒
        // 6.其他
        let param = {
          depId: this.depId
        }
        msgContractTotal(param).then(res => {
          if (res.status == 1) {
            this.htzs = res.data.contractTotal
            this.yfs = res.data.msgTotal
            res.data.msgTypeTotals.forEach(item => {
              if (item.msgType == 1) {
                this.qftx = item.msgTypeTotal
              } else if (item.msgType == 2) {
                this.yetx = item.msgTypeTotal
              } else if (item.msgType == 3) {
                this.cztx = item.msgTypeTotal
              } else if (item.msgType == 4) {
                this.khtx = item.msgTypeTotal
              } else if (item.msgType == 5) {
                this.bgtx = item.msgTypeTotal
              } else {
                this.qd = item.msgTypeTotal
              }
            })
          }
        })

      },

      getPieData() {
        let param = {
          depId: this.depId
        }
        findMsgDetailGroupTotal(param).then(res => {
          if (res.status == 1) {
            res.data.list.forEach(item => {
              if(item.name == '1'){
                item.name = '欠费提醒'
              }else if(item.name == '2'){
                item.name = '余额提醒'
              }else if(item.name == '3'){
                item.name = '充值提醒'
              }else if(item.name == '4'){
                item.name = '开户提醒'
              }else {
                item.name = '其他'
              }
            })
            let option = {
              tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
              },
              legend: {
                orient: 'vertical',
                x: 'right',
                y:'center',
                left:'70%'
                // data: ['欠费1', '欠费2', '欠费3', '欠费4']
              },
              grid:{

              },
              toolbox: {
                show: true,
                feature: {
                  mark: {
                    show: true
                  },
                  magicType: {
                    show: true,
                    type: ['pie', 'funnel'],
                    option: {
                      funnel: {
                        x: '25%',
                        width: '50%',
                        funnelAlign: 'left',
                        max: 1548
                      }
                    }
                  },
                }
              },
              calculable: true,
              series: [{

                type: 'pie',
                radius: '70%',
                center: ['30%', '50%'],
                data: res.data.list,
                label: {
                  normal: {
                    show: true,
                    formatter: "{b}\n({d}%)"
                  }
                }
              }]
            }
            this.chart = Chart.init(this.$refs.payEchart, 'macarons')
            this.chart.setOption(option)
          }
        })

      }
    }
  }
</script>

<style scoped>
  .theader{
    display: flex;
    justify-content: space-between;
  }
  .paybox {
    height: 300px;
  }
  .sheader{
    color: #2F308D;
    height: 32px;
    border-bottom: 1px solid #E5E5E5;
  }
  .sheader .icon{
    font-size: 22px;
    margin-right: 6px;
    position: relative;
    top: 3px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .txItem {
    height: 182px;
    margin-bottom: 26px;

  }

  .txItem .title,
  .htzs .title {
    color: #fff;
    font-size: 22px;
    padding: 18px;
  }

  .txLable {
    color: #fff;
    font-size: 36px;
    text-align: center;
  }

  .yfs {
    font-size: 30px;
    color: #fff;
    position: absolute;
    left: 20px;
    bottom: 20px;
  }

  .yetx {
    background: url(../../assets/img/yetx.png);
    background-size: 100% 100%;
  }

  .bgtx {
    background: url(../../assets/img/bgtx.png);
    background-size: 100% 100%;
  }

  .cztx {
    background: url(../../assets/img/cztx.png);
    background-size: 100% 100%;
  }

  .khtx {
    background: url(../../assets/img/khtx.png);
    background-size: 100% 100%;
  }

  .qftx {
    background: url(../../assets/img/qftx.png);
    background-size: 100% 100%;
  }

  .qt {
    background: url(../../assets/img/qt.png);
    background-size: 100% 100%;
  }

  .htzs {
    position: relative;
    height: 390px;
    background: url(../../assets/img/htzs.png);
    background-size: 100% 100%;
  }

  @media screen and (max-width: 1500px) {
    .txItem{
      height: 140px;
    }
    .htzs{
      height: 308px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/message/msgStatistics.vue